export const SUPPORTED_LOCALES = ["en", "es", "ca", "de", "fr", "it", "pt"] as const;
export type Locale = (typeof SUPPORTED_LOCALES)[number];

export const DEFAULT_LOCALE: Locale = "en";
export const LOCALE_COOKIE = "locale";
